import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "incidents-view" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "title-container" }

import { ref, computed, onMounted } from 'vue';
import { useIncidentStore } from '@/stores/useIncidentStore';
/* import IncidentActions from '@/components/incidents/IncidentActions.vue';
import IncidentFilters from '@/components/incidents/IncidentFilters.vue'; */
import IncidentListComponent from '@/components/incidents/IncidentListComponent.vue';
import IncidentSearchComponent from '@/components/incidents/IncidentSearchComponent.vue';
import IncidentFormComponent from '@/components/incidents/IncidentFormComponent.vue';
/* import IncidentFormModal from '@/components/incidents/IncidentFormModal.vue'; */
import type { Incident } from '@/types/incidentsTypes';

import { Plus } from 'lucide-vue-next';
import IncidentListComponentAux from '@/components/incidents/IncidentListComponentAux.vue';

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'IncidentsView',
  setup(__props) {

const incidentStore = useIncidentStore();

// State
const isFormModalOpen = ref(false);
const selectedIncident = ref<Incident | null>(null);
/* const currentFilters = ref<IncidentFilters>({}); */

// Computed
const filteredIncidents = computed(() => {
  return incidentStore.incidents.filter(incident => {
    // Lógica de filtrado según currentFilters
  });
});

// Handlers
const handleFormSubmit = async () => {
  await incidentStore.fetchIncidents();
};

const handleCloseModal = () => {
  isFormModalOpen.value = false;
};

const openCreateModal = () => {
  selectedIncident.value = null;
  isFormModalOpen.value = true;
};

const openEditModal = (incident: Incident) => {
  selectedIncident.value = incident;
  isFormModalOpen.value = true;
};
/* 
const handleFormSubmit = async (formData: IncidentForm) => {
  if (selectedIncident.value) {
    await incidentStore.updateIncident(formData);
  } else {
    await incidentStore.createIncident(formData);
  }
  isFormModalOpen.value = false;
}; */

const refreshIncidents = async () => {
  await incidentStore.fetchIncidents();
};

// Inicialización
onMounted(() => {
  incidentStore.fetchIncidents();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Gestión de Incidencias", -1)),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: openCreateModal
        }, [
          _createVNode(_unref(Plus)),
          _cache[0] || (_cache[0] = _createTextVNode(" Nueva Incidencia "))
        ])
      ]),
      _createVNode(IncidentSearchComponent)
    ]),
    _createVNode(IncidentListComponentAux),
    _createVNode(IncidentFormComponent, {
      show: isFormModalOpen.value,
      onClose: handleCloseModal,
      onSubmit: handleFormSubmit
    }, null, 8, ["show"])
  ]))
}
}

})